import { map } from 'rxjs/operators';

export default class UpgradePlanBloc {
  constructor({ userRepository, paymentRepository }) {
    this.userRepository = userRepository;
    this.paymentRepository = paymentRepository;
  }

  get userPlan$() {
    return this.userRepository.userDetails$.pipe(map((userDetails) => userDetails.userPlan));
  }

  async createPackageCheckoutSession(plan) {
    const { sessionId } = await this.paymentRepository.createPackageCheckoutSession(plan.name, 'upgrade-plan?action=upgradePackage');
    const result = await this.redirectToCheckout(sessionId);
    if (result.error) {
      console.log('createPackageCheckoutSession error', result.error);
    }
  }

  async createSubscriptionCheckoutSession(plan) {
    const { sessionId } = await this.paymentRepository.createSubscriptionCheckoutSession(plan.name, 'upgrade-plan?action=upgrade');
    const result = await this.redirectToCheckout(sessionId);
    if (result.error) {
      console.log('createSubscriptionCheckoutSession error', result.error);
    }
  }

  async redirectToCheckout(sessionId) {
    return this.paymentRepository.redirectToCheckout(sessionId);
  }
}
